module.exports = __webpack_public_path__ + "img/floor_f13_01.1eb975d9.png";